<template>
    <div>
         <div class="empty" >
            <div class="empty-main">
              <Spin size="large"></Spin>
            </div>
          </div>
    </div>
</template>

<script>
export default {
    data() {
        return {
        }
    },
}
</script>

<style lang="less" scoped>
 .empty {
      width: 100%;
      height: 50vh;
      font-size: 16px;
      position: relative;
      .empty-main {
        position: absolute;
        left: 50%;
        top: 50%;
        transform: translate(-50%,-50%);
        text-align: center;
        .empty-img {
          height: 160px;
          width: 160px;
        }
        .text{
          color:#999
        }
      }
    }
</style>